<template>
    <v-sheet>
        <v-tabs v-model="tab" color="primary" density="compact">
            <v-tab value="Detail">Detail</v-tab>
            <v-tab value="List">List</v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-window v-model="tab">
            <v-window-item value="Detail" class="py-3">
                <DetailWindow />
            </v-window-item>

            <v-window-item value="List" class="py-3">
                <ListWindow />
            </v-window-item>
        </v-window>
    </v-sheet>
</template>

<script>
import { defineAsyncComponent } from "vue";

const DetailWindow = defineAsyncComponent(() => import('./SubassembliesWindow/DetailWindow.vue'))
const ListWindow = defineAsyncComponent(() => import('./SubassembliesWindow/ListWindow.vue'))
const CommentsWindow = defineAsyncComponent(() => import('./SubassembliesWindow/CommentsWindow.vue'))

export default {
    name: "SubassembliesWindow",
    components: { DetailWindow, ListWindow, CommentsWindow },
    data() {
        return {
            tab: 'Detail'
        }
    }
}
</script>

<style scoped>

</style>
